<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <cost-center-form v-if="costCenter"
          @submit="submit"
          :init-cost-center="costCenter"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import CostCenterForm from './cost-center-form'

export default {
  components: { CostCenterForm },
  data () {
    return {
      costCenter: null,
      valErrors: []
    }
  },
  methods: {
    async submit (costCenter) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/cost_centers/${costCenter.id}`, costCenter).then(({ data }) => {
        this.$notify({
          message: 'Kostenstelle erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/cost_centers')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/cost_centers/${this.$route.params.id}`).then(({ data }) => {
      this.costCenter = data
    })
  }
}
</script>

<style>
</style>
